import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Spacing } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class IFrameConverter extends CmsConverterService<IFrameData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      url: formData?.st_url?.value ?? '',
      height: formData?.st_height?.value ?? 1000,
      heightMobile: formData?.st_height_mobile?.value,
      heightTablet: formData?.st_height_tablet?.value,
      fullWidth: formData?.st_full_width?.value ?? false,
      spacing: {
        top: formData?.spacing_top?.value?.identifier ?? '',
        bottom: formData?.spacing_bottom?.value?.identifier ?? ''
      }
    }
  }
}

export const IFRAME_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, IFrameData>>('IFrameConverter')

export interface IFrameData extends ConvertedComponentData {
  url: string;
  height: number;
  heightMobile: number;
  heightTablet: number;
  fullWidth: boolean;
  spacing: Spacing;
}
